var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor tavily-web-search" }, [
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilySearchQuery"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.tavilySearchQueryPh"),
            "show-attributes": true,
            "show-emoji": false,
          },
          model: {
            value: _vm.clone.query,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "query", $$v)
            },
            expression: "clone.query",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilySearchDepth"))),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            model: {
              value: _vm.clone.search_depth,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "search_depth", $$v)
              },
              expression: "clone.search_depth",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "basic" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyDepthBasic"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "advanced" } }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyDepthAdvanced"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyIncludeRaw"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_raw_content,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_raw_content", $$v)
            },
            expression: "clone.include_raw_content",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyIncludeImages"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_images,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_images", $$v)
            },
            expression: "clone.include_images",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyIncludeImageDescriptions"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_image_descriptions,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_image_descriptions", $$v)
            },
            expression: "clone.include_image_descriptions",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyIncludeAnswer"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.include_answer,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "include_answer", $$v)
            },
            expression: "clone.include_answer",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.openaiIncludeDomains"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.clone.include_domains, function (domain, index) {
          return _c(
            "div",
            { key: "domain-" + index, staticClass: "key-value-pair" },
            [
              _c("a-input", {
                staticClass: "domain-input",
                attrs: { placeholder: _vm.$t("chatbotv2.openaiDomainPh") },
                model: {
                  value: _vm.clone.include_domains[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.include_domains, index, $$v)
                  },
                  expression: "clone.include_domains[index]",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "link", danger: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeDomain(index)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("delete"),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "a-button",
          {
            staticClass: "add-btn",
            attrs: { type: "dashed", block: "" },
            on: { click: _vm.addDomain },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(
              " " + _vm._s(_vm.$t("chatbotv2.openaiAddDomain")) + "\n        "
            ),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.tavilyMaxResults"))),
        ]),
        _vm._v(" "),
        _c("a-input-number", {
          attrs: { min: 1, max: 10 },
          model: {
            value: _vm.clone.max_results,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "max_results", $$v)
            },
            expression: "clone.max_results",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }